import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import {
  downloadMaintenancePdf,
  type MaintenancePdfInput,
} from "@/lib/maintenance-pdf";

export function MaintenancePdfButton({
  build,
  label = "Download PDF checklist",
  className = "",
  secondary = false,
}: {
  build: () => MaintenancePdfInput;
  label?: string;
  className?: string;
  /** Renders the blue secondary treatment; gold stays the page's one CTA. */
  secondary?: boolean;
}) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await downloadMaintenancePdf(build());
    } catch {
      // swallow — the button simply returns to its idle state
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className={`${secondary ? "inline-flex items-center gap-2 rounded-md border border-primary px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/10 disabled:opacity-60" : "cta-gold rounded-md"} ${className}`}
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
      ) : (
        <Download className="h-4 w-4" aria-hidden />
      )}
      {busy ? "Preparing PDF…" : label}
    </button>
  );
}
